import { useEffect } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '@aws-amplify/ui-react/styles.css';

/**
 * Login / sign-up page using Amplify Authenticator.
 * After sign-in, redirects to ?returnTo= param or home.
 */
function LoginView() {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/';

  useEffect(() => {
    if (isLoggedIn) {
      navigate(returnTo, { replace: true });
    }
  }, [isLoggedIn, navigate, returnTo]);

  return (
    <div className='login-container'>
      <Authenticator
        loginMechanisms={['email']}
        signUpAttributes={[]}
      />
    </div>
  );
}

export default LoginView;
